document.addEventListener("DOMContentLoaded", function () {

  const stickyBar = document.getElementById("sticky-cart-bar");
  const addBtn = document.getElementById("sticky-add-to-cart");
  const productForm = document.querySelector('form[action*="/cart/add"]');

  if (!stickyBar || !productForm) return;

  const productData = JSON.parse(
    document.getElementById("sticky-product-json").textContent
  );

  // =========================
  // SHOW / HIDE STICKY BAR
  // =========================

  const productInfoSection =
    document.querySelector('.ProductMeta') ||
    document.querySelector('.ProductForm__Variants') ||
    productForm;

  // =========================
  // BACKTOP BUTTON - STICKY CART SE SHIFT
  // =========================

  function adjustBackTopPosition() {
    const backTop = document.querySelector('.BackTop');
    if (!backTop) return;

    const isSticky = stickyBar && stickyBar.classList.contains('show-sticky');

    if (isSticky) {
      const stickyHeight = stickyBar.offsetHeight || 70;
      backTop.style.bottom = (25 + stickyHeight) + 'px';
      backTop.style.transition = 'bottom 0.3s ease-in-out';
    } else {
      backTop.style.bottom = '25px';
      backTop.style.transition = 'bottom 0.3s ease-in-out';
    }
  }

  function toggleStickyCart() {

    if (!productInfoSection) {
      if (window.scrollY > 300) {
        stickyBar.classList.remove('hide-sticky');
        stickyBar.classList.add('show-sticky');
      } else {
        stickyBar.classList.remove('show-sticky');
        stickyBar.classList.add('hide-sticky');
      }
      adjustBackTopPosition();
      return;
    }

    const rect = productInfoSection.getBoundingClientRect();

    if (rect.bottom < 80) {
      stickyBar.classList.remove('hide-sticky');
      stickyBar.classList.add('show-sticky');
    } else {
      stickyBar.classList.remove('show-sticky');
      stickyBar.classList.add('hide-sticky');
    }

    adjustBackTopPosition();
  }

  // window.addEventListener('scroll', toggleStickyCart, { passive: true });
  window.addEventListener('scroll', adjustBackTopPosition, { passive: true });

stickyBar.classList.remove('hide-sticky');
stickyBar.classList.add('show-sticky');

adjustBackTopPosition();
  // =========================
  // FORMAT MONEY
  // =========================

  function formatMoney(price) {
    if (
      window.Shopify &&
      typeof Shopify.formatMoney === "function" &&
      window.stickyMoneyFormat
    ) {
      return Shopify.formatMoney(price, window.stickyMoneyFormat);
    }
    const rupees = Math.round(price / 100);
    const formatted = rupees.toLocaleString('en-IN');
    return `${window.stickyCurrency || "₹"} ${formatted}`;
  }

  // =========================
  // GET CURRENT VARIANT
  // =========================

  function getSelectedVariant() {

    const checkedRadio = document.querySelector(
      'input[type="radio"][name="option-0"]:checked'
    );

    if (!checkedRadio) {
      return null;
    }

    const selectedValue = checkedRadio.value;

    const matchedVariant = productData.variants.find(variant =>
      variant.option1 === selectedValue
    );

    return matchedVariant || null;
  }

  // =========================
  // CLOSE DROPDOWNS
  // =========================

  function closeAllDropdowns() {
    document.querySelectorAll('.sticky-custom-select.active').forEach(select => {
      select.classList.remove('active');
    });
  }

  // =========================
  // UPDATE STICKY UI
  // =========================

  function updateStickyUIFromVariant() {

    const variant = getSelectedVariant();

    // PRICE
    const priceEl = document.getElementById("sticky-price");
    if (priceEl) {
      if (variant) {
        const price = variant.price;
        const compare = variant.compare_at_price;
        if (compare && compare > price) {
          priceEl.innerHTML = `<s>${formatMoney(compare)}</s> ${formatMoney(price)}`;
        } else {
          priceEl.innerHTML = formatMoney(price);
        }
      }
    }

    // IMAGE
    const stickyImage = document.getElementById("sticky-variant-image");
    if (stickyImage && variant) {
      let imageUrl = null;
      if (variant.featured_image && variant.featured_image.src) {
        imageUrl = variant.featured_image.src;
      } else {
        imageUrl = productData.featured_image;
      }
      if (imageUrl) stickyImage.src = imageUrl;
    }

    // OPTIONS
    document.querySelectorAll('.sticky-custom-select').forEach((selectContainer, index) => {
      const triggerText = selectContainer.querySelector('.sticky-select-value');
      const optionButtons = selectContainer.querySelectorAll('.sticky-select-option');

      const checkedRadio = document.querySelector(
        `input[type="radio"][data-option-position="${index + 1}"]:checked`
      );
      const currentValue = checkedRadio ? checkedRadio.value : null;

      if (triggerText) {
        triggerText.textContent = currentValue || `Select Size`;
      }

      optionButtons.forEach(btn => {
        btn.classList.remove('active');
        if (currentValue && btn.getAttribute('data-value') === currentValue) {
          btn.classList.add('active');
        }
      });
    });
  }

  // =========================
  // SYNC WITH PRODUCT PAGE
  // =========================

  function syncWithProductPage(optionPosition, value) {

    const currentSelect = document.querySelector(
      `.sticky-custom-select[data-option-position="${optionPosition}"]`
    );

    if (currentSelect) {
      currentSelect.querySelectorAll('.sticky-select-option').forEach(btn => {
        btn.classList.remove('active');
        if (btn.getAttribute('data-value') === value) btn.classList.add('active');
      });
      const triggerText = currentSelect.querySelector('.sticky-select-value');
      if (triggerText) triggerText.textContent = value;
    }

    const productSelects = document.querySelectorAll('form[action*="/cart/add"] select');
    if (productSelects[optionPosition - 1]) {
      productSelects[optionPosition - 1].value = value;
      productSelects[optionPosition - 1].dispatchEvent(new Event('change', { bubbles: true }));
    }

    const radioInputs = document.querySelectorAll(`input[type="radio"][value="${value}"]`);
    radioInputs.forEach(radio => {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      radio.dispatchEvent(new Event('click', { bubbles: true }));
    });

    setTimeout(() => {
      const variant = getSelectedVariant();
      if (!variant) return;

      const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateStickyUIFromVariant();
    }, 100);
  }

  // =========================
  // CUSTOM SELECTS INIT
  // =========================

  function initCustomSelects() {

    document.querySelectorAll('.sticky-custom-select').forEach(selectContainer => {

      const trigger = selectContainer.querySelector('.sticky-select-trigger');
      const options = selectContainer.querySelectorAll('.sticky-select-option');

      trigger.addEventListener('click', () => {
        const isActive = selectContainer.classList.contains('active');
        closeAllDropdowns();
        if (!isActive) selectContainer.classList.add('active');
      });

      options.forEach(option => {
        if (option.getAttribute('data-available') === 'false') return;

        option.addEventListener('click', () => {
          const value = option.getAttribute('data-value');
          const optionPosition = selectContainer.getAttribute('data-option-position');
          syncWithProductPage(optionPosition, value);
          closeAllDropdowns();
        });
      });
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.sticky-custom-select')) {
        closeAllDropdowns();
      }
    });
  }

  // =========================
  // PRODUCT PAGE → STICKY SYNC
  // =========================

  document.addEventListener("change", function () {
    setTimeout(() => updateStickyUIFromVariant(), 150);
  });

  // =========================
  // INIT
  // =========================

  initCustomSelects();

  setTimeout(() => updateStickyUIFromVariant(), 300);

  // BackTop initial position set karo
  setTimeout(() => adjustBackTopPosition(), 400);

});


document.querySelectorAll('.sticky-atc-btn').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();

    document
      .querySelector('.res-sricky-btn .ProductForm__AddToCart')
      ?.click();
  });
});

document.querySelectorAll('.sticky-buynow-btn').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();

    document
      .querySelector('.res-sricky-btn .add--to_chekout')
      ?.click();
  });
});